export const getAdminDisputeSearchContainerStyle = (theme) => ({
    textAlign: 'center',
    width: '750px',
    marginLeft: 'auto',
    marginRight: 'auto'
});